var map = {
	"./approve.png": "18b7",
	"./bg.png": "3f6e",
	"./blue.png": "4901",
	"./buy-logo.png": "3167",
	"./buy.png": "ed16",
	"./configListEdit/noConfig.png": "dddb",
	"./default.png": "6bcd",
	"./err.png": "9b34",
	"./faceRecognition.png": "8125",
	"./functionIcon/data.png": "64a8",
	"./functionIcon/nav.png": "18d4",
	"./functionIcon/open.png": "b78f",
	"./functionIcon/ringing.png": "2b47",
	"./functionIcon/search.png": "773f",
	"./functionIcon/task.png": "a598",
	"./green.png": "9fc8",
	"./login/login-logo.png": "0615",
	"./login/qrcode-login.png": "a504",
	"./login/qrcode.png": "b4d4",
	"./login/web-login.png": "c117",
	"./logo-mini.png": "a2c8",
	"./logo.png": "9d64",
	"./ok.png": "d455",
	"./old.png": "2d5dd",
	"./red.png": "5be9",
	"./szy.png": "2da2",
	"./telA.png": "1ce0",
	"./telB.png": "075c",
	"./trabe1.png": "4b18",
	"./trabe2.png": "ff42",
	"./trabe3.png": "e1eb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";